import styles from './ui/PsychicCardTile.module.scss';

export { default as PsychicCardTile } from './ui';
const { tileCardWidth } = styles;
export { tileCardWidth };
